export default "__VITE_ASSET__40fdeac8__"